import ProcessRoutes from "../reporting/process.js";

export default [...ProcessRoutes];
